export const UnknownConfigLanguage = (language: string) =>
  new Error(`A configured language is not available in the application: ${language}`);

export const UnknownEmissionTypeError = (type: string) => new Error(`The emission type unknown: ${type}`);

export const GetRegionsBoundsLengthError = () =>
  new Error(`Regions entered in this function should be present. Add guards before calling this function.`);

export const DropzoneSingleFileRequirementError = () =>
  new Error(`This dropzone can only handle a single file. Ensure mutliple files can't occur.`);
